import styled, { css } from "styled-components";
import { colors } from "../../theme/color";

const alertVariants = ({ variant }: any) => css`
  position: relative;
  border-radius: 0.5rem;
  border: 1px solid;
  padding: 0.1rem 1rem;
  font-size: 0.875rem; /* Assuming base font size of 1rem */

  & > svg + div {
    transform: translateY(-3px);
  }

  & > svg {
    position: absolute;
    left: 1.5rem; /* Assuming base spacing of 1rem */
    top: 1.5rem;
    color: ${({ theme }) => colors.Primary};
  }

  & > svg ~ * {
    padding-left: 2.875rem; /* svg width + spacing */
  }

  ${variant === "destructive" &&
  css`
    border-color: ${({ theme }) => colors.DANGER} / 50;
    color: ${({ theme }) => colors.DANGER};

    & > svg {
      color: ${({ theme }) => colors.DANGER};
    }
  `}
`;

export const Alert = styled.div<{ variant?: any }>`
  ${alertVariants}
  role: alert;
  padding: 1rem;
`;

Alert.displayName = "Alert";

export const AlertTitle = styled.h5`
  margin: 0.01rem;
  font-weight: 500;
`;

AlertTitle.displayName = "AlertTitle";

export const AlertDescription = styled.div`
  font-size: 0.875rem; /* Assuming base font size of 1rem */

  & > p {
    line-height: 1.75; /* Assuming looser line-height for paragraphs */
  }
`;

AlertDescription.displayName = "AlertDescription";

// export { Alert, AlertTitle, AlertDescription };
